import {ApiProperty} from "@nestjs/swagger";

export class RequestByName{
    @ApiProperty()
    visitorName: any;

}